<template>
  <router-view></router-view>
</template>

<script>
  import NotificationSample from 'src/pages/Dashboard/Components/NotificationSample';
  export default {
    beforeCreate () {
      if (!localStorage.vposAppAuth) {
        if (this.$route.name !== 'Register'
         && this.$route.name !== 'Login'
         && this.$route.name !== 'Confirmation'
         && this.$route.name !== 'ResetPassRequest'
         && this.$route.name !== 'ResetPass'
         && this.$route.name !== 'GoogleLogin')
          this.$router.replace({name: 'Login'})
        } else {
          if(this.$route.name === 'Register' || this.$route.name === 'Login' || this.$route.name === 'GoogleLogin')
          this.$router.replace('/')
      }
    },
    watch: {
      '$route' (to, from) {
        if (!localStorage.vposAppAuth) {
          if (to.name !== 'Register'
           && to.name !== 'Login'
           && to.name !== 'Confirmation'
           && to.name !== 'ResetPassRequest'
           && to.name !== 'ResetPass'
           && to.name !== 'GoogleLogin')
            this.$router.replace({name: 'Login'})
        } else {
          if(to.name === 'Register' || to.name === 'Login' || to.name === 'GoogleLogin')
            this.$router.replace('/')
        }
      }
    }
  }
</script>
